import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Layout } from 'antd';

import { withContainerWrapper } from '../ContainerWrapper';
import { hasPermission } from '../../utils/Permissions';
import EnterprisePromotion from '../../components/global/EnterprisePromotion/EnterprisePromotion';
import { ApplicationState } from '../../reducers';
import ImportPage from '../../components/body/import_export/ImportPage';
import {
  fetchImportBrandStatus,
  fetchImportOptions,
} from '../../actions/brand/import_export/fetch';

const { Content } = Layout;

const ImportContainer: React.FC = () => {
  const dispatch = useDispatch();

  const user = useSelector((state: ApplicationState) => state.user.user);
  const brandId = useSelector((state: ApplicationState) => state.parent.brands.selectedBrandId);

  const hasImportAccess = useMemo(() => hasPermission(user, 'has_import_access'), [user]);

  React.useEffect(() => {
    dispatch(fetchImportBrandStatus(brandId));
    dispatch(fetchImportOptions(brandId));
  }, [dispatch, brandId]);

  return (
    <Content className="import-page__content">
      {!hasImportAccess ? <EnterprisePromotion /> : <ImportPage />}
    </Content>
  );
};

export default withContainerWrapper(ImportContainer);
